import styled from 'styled-components';

// Components
import { Colors, Spacing } from '@doordash/design-language';
import { Checkbox } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';

export const Body = styled.div`
  padding: 0 1.25rem 0 0.625rem;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0;
    margin-left: -0.625rem;
  }

  .ant-form-item-control-input {
    min-height: auto;
    padding: 0.125rem 0;
  }
`;

export const Container = styled.div`
  border-top: 6px solid ${Colors.BackgroundSecondary};

  &:not(:first-of-type) {
    margin-top: 1.25rem;
  }

  @media (min-width: ${breakpoints.md}px) {
    border-top: 0;
    margin-top: 1.75rem;
  }
`;

export const CustomCheckbox = styled(Checkbox)``;

export const Description = styled.div`
  color: var(--bose-item__modifier-subtitle);
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  flex-direction: row;
  margin: 0.5rem 0;

  span {
    opacity: 0.8;
  }

  .error {
    color: var(--color-error__regular);
    opacity: 1;

    &--selection-required {
      color: var(--color-error__regular);
      flex-shrink: 0;
      opacity: 1;
      padding-left: 1rem;

      &::before {
        content: '* Selection ';
      }
    }
  }

  @media (min-width: ${breakpoints.md}px) {
    font-size: 0.875rem;
  }
`;

export const Header = styled.div`
  margin: 1.25rem 1.25rem 0.5rem;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0;
  }
`;

export const Heading = styled.h6`
  color: var(--bose-item__modifier-title);
  font-size: ${Spacing.Small}px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 0.875rem;
`;
